
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import { common as enCommon } from './local/en/common';
import { financing as enFinancing } from './local/en/financing';
import { common as frCommon } from './local/fr/common';
import { financing as frFinancing } from './local/fr/financing';

const resources = {
  en: {
    common: enCommon,
    financing: enFinancing
  },
  fr: {
    common: frCommon,
    financing: frFinancing
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
